export const fromEntriesPolyfill = (iterable: IterableIterator<[string, string]>) => {
    return [...iterable].reduce((obj: Record<string, string>, [key, val]) => {
        obj[key] = val;

        return obj;
    }, {});
};
